import { useTranslation } from 'react-i18next'
import * as yup from 'yup'

import { EmployeesInvitationForm } from '../employees-invitation-interface'

export const EmployeesInvitationValidationSchema = () => {
  const { t } = useTranslation()

  return yup.object<EmployeesInvitationForm>({
    emails: yup.array().of(yup.string().email(t('emailErrors.invalidEmail')).required(t('emailErrors.emailRequired'))),
  })
}
